import { useState } from 'react';
import { api, rotas } from '@shared/lib/api';
import s from './Login.module.css';

/**
 * "Reenviar o link de confirmação", com e-mail E SENHA.
 *
 * A senha vai junto porque é ela que prova que quem pede é quem se
 * cadastrou (ver api/rotas/cadastro_cliente.py, `reenviar`). Por isso o
 * botão só aparece onde a senha já está à mão: logo depois do cadastro,
 * e no login que o Auth recusou por falta de confirmação -- recusa que,
 * de quebra, já confirmou que a senha estava certa.
 *
 * A API responde igual com ou sem envio (não diz se o e-mail existe).
 * O texto de sucesso, então, é o que a pessoa precisa fazer, não a
 * afirmação de que algo saiu.
 */
export function Reenvio({ email, senha, destino }: {
  email: string; senha: string; destino?: string | null;
}) {
  const [estado, setEstado] = useState<'parado' | 'enviando' | 'enviado'>('parado');
  const [erro, setErro] = useState<string | null>(null);

  async function reenviar() {
    setErro(null);
    setEstado('enviando');
    try {
      await api.post(rotas.cadastroReenviar, { email, senha, destino: destino ?? null });
      setEstado('enviado');
    } catch (err) {
      setEstado('parado');
      // 429 já vem com a frase certa ("aguarde um minuto").
      setErro((err as Error).message);
    }
  }

  return (
    <div className={s.reenvio}>
      <button type="button" className={s.botaoSecundario}
              onClick={() => void reenviar()} disabled={estado === 'enviando'}>
        {estado === 'enviando' ? 'Enviando…'
          : estado === 'enviado' ? 'Enviar de novo' : 'Reenviar o link de confirmação'}
      </button>
      {estado === 'enviado' && (
        <div className={s.ok} role="status">
          Pedido feito. Confira sua caixa de entrada, e também o spam: o link
          novo substitui o anterior.
        </div>
      )}
      {erro && <div className={s.erro}>{erro}</div>}
    </div>
  );
}
